/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';

import template from './retail-product-conversion-tracking-modal.component.html';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';
import {CpaDefaults} from '../line-item/cpa-defaults';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-retail-product-conversion-tracking-modal',
  template
})
export class RetailProductConversionTrackingModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  product: any;

  adSourceMode: 'ITEM_ID' | 'BRAND' = 'ITEM_ID';
  cpaLink = '';
  cpaScript = '';

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LocalNetworkProfile) private readonly LocalNetworkProfile: any
  ) {
  }

  ngOnInit(): void {
    if (!this.product?.itemId && this.product?.brand) {
      this.adSourceMode = 'BRAND';
    }
    this.updatePixelCode();
  }

  getAdSource(): string | null {
    if (!this.product) {
      return null;
    }
    if (this.adSourceMode === 'BRAND') {
      return this.product.brand || null;
    }
    return this.product.itemId || null;
  }

  updatePixelCode(): void {
    const adSource = this.getAdSource();
    const tagId = this.LocalNetworkProfile.get('tagId');
    this.cpaLink = CpaDefaults.getLink(null, tagId, adSource);
    this.cpaScript = CpaDefaults.getScript(null, tagId, adSource);
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }
}
